import { lazily } from '../utils/helpers';
import { USER_ROLES, USER_STATUS } from '../utils/types/user';

export const APP_ROUTES = {
  MAIN: '/',
  FAQ: '/faq',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',
  ALLPOSTS: '/allposts?tab=blogposts',
  EVENTS_NEW: '/story-ideas',
  EVENTPOST: (id?: string | number) =>
    `/story-ideas/${id || ':id'}`,
  REG_AS_EXPERT1: '/register/expert/1',
  REG_AS_EXPERT2: '/register/expert/2',
  REG_AS_EXPERT3: '/register/expert/3',
  STRIPE_CHECKOUT: (planId?: string | number) =>
    `/expert/checkout/${planId || ':planId'}`,
  REG_AS_JOURNALIST: '/register/journalist',
  PAYMENT_SUCESS: '/expert/payment/sucess',
  PAYMENT_FAIL: '/expert/payment/failed',
  TEST: '/test',
  CONTACTS: '/contacts',
  LOGIN: '/login',
  LINKEDIN_CALLBACK: '/login/callback/linkedin',
  GOOGLE_CALLBACK: '/login/callback/google',
  FN_RECOVERY_PASSWORD: (token?: string | number) =>
    `/password-recovery/${token || ':token'}`,

  // Journalist`s routes
  JOURNALIST_DASHBOARD: '/dashboard',
  JOURNALIST_DASHBOARD_ID: (name?: string | number) =>
    `/dashboard/${name || ':name'}`,
  DIRECTORY: '/directory',
  ALL_CONTACTS: '/directory/all-contacts',

  // areas
  AREAS: '/areas',
  FN_PROFILE_UPDATE: (areasID?: string) =>
    `/profile/upload/${areasID || ':id'}`,
  PROFILE_UPDATE: '/profile/update',

  // New contact
  NEW_CONTACTS: '/directory/new-contacts',
  CREATE_CONTACT: '/directory/new-contacts/create',
  FN_UPLOAD_CONTACT_MEDIA: (guestId?: string | number) =>
    `/directory/new-contacts/upload/${guestId || ':id'}`,

  UPLOAD_CONTACTS: '/directory/upload-contacts',
  NEWS_EXPLORER: '/news-explorer',
  CSV_DOWNLOAD: '/csv-download',

  EMAIL_TEMPLATES: '/email-templates',
  EMAIL_TEMPLATES_ALL: '/email-templates/all',
  EMAIL_TEMPLATES_NEW: '/email-templates/new',
  FN_EMAIL_TEMPLATES_TEMPLATE: (emailId?: number) =>
    `/email-templates/edit/${emailId || ':id'}`,

  FN_CONTACT_DETAILS: (userId?: string | number) =>
    `/contact/${userId || ':id'}`,
  FN_CONTACT_DETAILS_OVERVIEW: (userId?: string | number) =>
    `/contact/${userId || ':id'}/overview`,
  FN_CONTACT_DETAILS_GENERAL: (userId?: string | number) =>
    `/contact/${userId || ':id'}/general`,
  FN_CONTACT_DETAILS_MEDIA: (userId?: string | number) =>
    `/contact/${userId || ':id'}/media`,
  JOURNALIST_PROFILE: '/profile/journalist',
  JOURNALIST_PERSONAL_INFO: '/profile/journalist/personal-info',
  JOURNALIST_COMPANY: '/profile/journalist/company',
  JOURNALIST_SECURITY: '/profile/journalist/security',

  // Journalist Interviews
  JOURNALIST_ALL_INTERVIEWS: '/interviews/journalist/all',
  JOURNALIST_PLANNED_INTERVIEWS: '/interviews/journalist/planned',
  JOURNALIST_PROCESS_INTERVIEWS: '/interviews/journalist/process',

  // Questions
  JOURNALIST_QUESTIONS: '/questions/journalist',

  JOURNALIST_RESOURCES: '/resources',
  
  JOURNALIST_RESOURCES_PITCHMARK: '/resources/pitchmark/dashboard',
	
  PITCHMARK_SENDOFFER: '/resources/pitchmark/send-invite',

  // ******* Expert`s routes *******
  EXPERT_PROFILE: '/profile/expert',
  EXPERT_COMPANY: '/profile/expert/company',
  EXPERT_PERSONAL_INFO: '/profile/expert/personal-info',

  CONTACTS_MANAGER: '/contacts-manager/expert',
  CREATE_NEWS_CONTACTS_MANAGER: '/contacts-manager/expert/news/create',
  FN_EDIT_NEWS_CONTACTS_MANAGER: (newsId?: number) =>
    `/contacts-manager/expert/news/edit/${newsId || ':id'}`,
  NEWS_CONTACTS_MANAGER: '/contacts-manager/expert/news',

  // EVENTS
  EVENTS: '/background-briefing/create/',
  EVENTS_LIST: '/background-briefing/list',
  EDIT_EVENT: (eventId?: number) =>
    `/background-briefing/edit-and-view/${eventId || ':id'}`,
  CREATE_EVENTS: '/background-briefing/create',
  FN_EDIT_EVENTS_EVENT: (eventId?: number) =>
    `/background-briefing/edit/${eventId || ':id'}`,
  EVENTS_EVENT: '/background-briefing',
  FN_EVENT_DETAIL: (eventId?: number) => `/event-detail/${eventId || ':id'}`,

  EXPERT_SECURITY: '/profile/expert/security',
  EXPERT_PAYMENT: '/profile/expert/payment',
  EXPERT_GUEST: '/profile/expert/guests',
  TEAM_MEMBERS: '/profile/expert/team-members',

  // New guest
  NEW_GUEST: '/guests/new-guest',
  CREATE_GUEST: '/guests/new-guest/create',
  FN_UPLOAD_GUEST_MEDIA: (guestId?: string | number) =>
    `/guests/new-guest/upload/${guestId || ':id'}`,
  UPLOAD_GUESTS: '/guests/upload',

  GUESTS: '/guests',
  FN_GUEST_DETAILS: (userId?: string | number) => `/guests/${userId || ':id'}`,
  FN_GUEST_DETAILS_OVERVIEW: (userId?: string | number) =>
    `/guests/${userId || ':id'}/overview`,
  FN_GUEST_DETAILS_GENERAL: (userId?: string | number) =>
    `/guests/${userId || ':id'}/general`,
  FN_GUEST_DETAILS_MEDIA: (userId?: string | number) =>
    `/guests/${userId || ':id'}/media`,

  FN_GUEST_DETAILS_INFO: (userId?: string | number) =>
    `/profile/${userId || ':id'}`,
  FN_GUEST_DETAILS_OVERVIEW_INFO: (userId?: string | number) =>
    `/guests/${userId || ':id'}/overview`,
  FN_GUEST_DETAILS_GENERAL_INFO: (userId?: string | number) =>
    `/guests/${userId || ':id'}/general`,

  // Expert Interviews
  EXPERT_PENDING_INTERVIEWS: '/interviews/expert/pending',
  EXPERT_PLANNED_INTERVIEWS: '/interviews/expert/planned',
  EXPERT_ARCHIVE_INTERVIEWS: '/interviews/expert/archive',

  EXPERT_QUESTIONS: '/questions/expert',
  SURVEY_FORM: '/survey-form',
  EXPERT: '/expert',
  THANK_YOU: '/thank-you',
  
  EXPERT_DEEPLINK: (name?: string | number) =>
    `/expert/${name || ':name'}`,
	
} as const;

const { LandingPage } = lazily(() => import('src/pages/LandingPage'));
const { EventDetail } = lazily(() => import('src/pages/events-detail'));

const { ContactsPage } = lazily(
  () => import('src/pages/ContactsPage/ContactsPage'),
);
export const { Test } = lazily(() => import('src/pages/test/Test'));

const { RegisterAsExpert1New } = lazily(
  () => import('../pages/auth/registerAsExpert/RegisterAsExpert1New'),
);
const { GoogleCallback } = lazily(
  () => import('../pages/auth/oauth/GoogleCallback'),
);
const { EventsNew } = lazily(
  () => import('../pages/eventsnew/EventsNew'),
);
const { EventPost } = lazily(
  () => import('../pages/eventsnew/EventPost'),
);
const { RegisterAsExpert2 } = lazily(
  () => import('../pages/auth/registerAsExpert/RegisterAsExpert2'),
);

const { RegisterAsExpert3 } = lazily(
  () => import('../pages/auth/registerAsExpert/RegisterAsExpert3'),
);

const { RegisterAsJournalist } = lazily(
  () => import('../pages/auth/RegisterAsJournalist'),
);
const { LinkedInCallback } = lazily(
  () => import('../pages/auth/oauth/LinkedInCallback'),
);

const { NotFound } = lazily(() => import('../pages/NotFound'));

const { Faq } = lazily(() => import('../pages/faq/Faq'));

const { TermsAndConditions } = lazily(() => import('src/pages/TermsAndConditions'));

const { PrivacyPolicy } = lazily(() => import('src/pages/PrivacyPolicy'));

const { Paymentsuccess } = lazily(() => import('../features/user/expert/profile/payments/subscriptionForm/Paymentsuccess'));

const { Paymentfailed } = lazily(() => import('../features/user/expert/profile/payments/subscriptionForm/Paymentfailed'));

const { Allposts } = lazily(() => import('../pages/allposts/AllPosts'));

const { RecoveryPassword } = lazily(
  () => import('../pages/auth/passwordRecovery/RecoveryPassword'),
);

const { StripePayment } = lazily(
  () => import('src/features/user/expert/profile/payments/subscriptionForm/StripePayment'),
);

const { SurveyForm } = lazily(
  () => import('src/pages/survey-form/index'),
);

const { Expert } = lazily(
  () => import('src/pages/landing/expert/Expert'),
);

const { ThankYou } = lazily(
  () => import('src/pages/landing/expert/ThankYou'),
);

const { ExpertDeeplink } = lazily(
  () => import('src/pages/deeplink/ExpertDeeplink'),
);

export interface IRoute {
  path: string;
  component: any;
  exact?: boolean;
  userStatuses?: Array<USER_STATUS>;
  roles?: Array<USER_ROLES>;
  routes?: Array<IRoute>;
}

export const REGISTER_AS_EXPERT2_ROUTE: IRoute = {
  path: APP_ROUTES.REG_AS_EXPERT2,
  component: RegisterAsExpert2,
  roles: [USER_ROLES.EXPERT],
  userStatuses: [USER_STATUS.MUST_ADD_GUEST],
};

export const REGISTER_AS_EXPERT3_ROUTE: IRoute = {
  path: APP_ROUTES.REG_AS_EXPERT3,
  component: RegisterAsExpert3,
  roles: [USER_ROLES.EXPERT],
  userStatuses: [USER_STATUS.MUST_PAY],
};

export const EXPERT_CHECKOUT: IRoute = {
  path: APP_ROUTES.STRIPE_CHECKOUT(),
  component: StripePayment,
  roles: [USER_ROLES.EXPERT],
  userStatuses: [USER_STATUS.MUST_PAY, USER_STATUS.SIMPLE_USER],
};

/* export const EVENTSNEW_ROUTE: IRoute = {
    path: APP_ROUTES.EVENTS_NEW,
    component: EventsNew,
    roles: [USER_ROLES.JOURNALIST, USER_ROLES.EXPERT],
    userStatuses: [USER_STATUS.SIMPLE_USER],
}; */

/* export const EVENTPOST_ROUTE: IRoute = {
  path: APP_ROUTES.EVENTPOST(),
  component: EventPost,
  roles: [USER_ROLES.JOURNALIST, USER_ROLES.EXPERT],
  userStatuses: [USER_STATUS.SIMPLE_USER],
}; */

export const routes: Array<IRoute> = [
  {
    path: APP_ROUTES.MAIN,
    component: LandingPage,
  },

  {
    path: APP_ROUTES.FAQ,
    component: Faq,
  },
  
  {
	path: APP_ROUTES.TERMS_AND_CONDITIONS,
	component: TermsAndConditions,
  },
  
  {
	path: APP_ROUTES.PRIVACY_POLICY,
	component: PrivacyPolicy,
  },
  
  {
    path: APP_ROUTES.ALLPOSTS,
    component: Allposts,
  },
  
  {
    path: APP_ROUTES.EVENTPOST(),
    component: EventPost,
  },
  
  {
    path: APP_ROUTES.EVENTS_NEW,
    component: EventsNew,
  },

  {
    path: APP_ROUTES.FN_EVENT_DETAIL(),
    component: EventDetail,
  },
  {
    path: APP_ROUTES.REG_AS_EXPERT1,
    component: RegisterAsExpert1New,
  },
  {
    path: APP_ROUTES.REG_AS_EXPERT2,
    component: RegisterAsExpert2,
  },
  {
    path: APP_ROUTES.REG_AS_JOURNALIST,
    component: RegisterAsJournalist,
  },
  {
    path: APP_ROUTES.PAYMENT_SUCESS,
    component: Paymentsuccess,
  },
  {
    path: APP_ROUTES.PAYMENT_FAIL,
    component: Paymentfailed,
  },
  {
    path: APP_ROUTES.TEST,
    component: Test,
  },
  {
    path: APP_ROUTES.GOOGLE_CALLBACK,
    component: GoogleCallback,
  },
  {
    path: APP_ROUTES.LINKEDIN_CALLBACK,
    component: LinkedInCallback,
  },
  {
    path: APP_ROUTES.CONTACTS,
    component: ContactsPage,
  },
  {
    path: APP_ROUTES.FN_RECOVERY_PASSWORD(),
    component: RecoveryPassword,
  },
  {
    path: APP_ROUTES.SURVEY_FORM,
    component: SurveyForm,
  },
  {
    path: APP_ROUTES.EXPERT,
    component: Expert,
  },
  {
    path: APP_ROUTES.THANK_YOU,
    component: ThankYou,
  },
  {
    path: APP_ROUTES.EXPERT_DEEPLINK(),
    component: ExpertDeeplink,
  },
  {
    path: '*',
    component: NotFound,
  },
];
